import { api } from '../../../lib/api';
import type { PagedResult } from '../../administration/users/userTypes';
import type { SurveyTrainingRecommendation } from '../survey/surveyTypes';

/** What the register may be narrowed by. */
export interface TrainingRecommendationListQuery {
  search?: string;
  page?: number;
  pageSize?: number;
  sort?: string;
  /** The recommendation's own live-or-deleted state — the shell's key. */
  status?: string;
}

function toQueryString(query: TrainingRecommendationListQuery): string {
  const params = new URLSearchParams();

  if (query.search?.trim()) params.set('search', query.search.trim());
  if (query.page && query.page > 1) params.set('page', String(query.page));
  if (query.pageSize) params.set('pageSize', String(query.pageSize));
  if (query.sort) params.set('sort', query.sort);

  // Sent whenever PRESENT, empty string included — "none of these" matches no row.
  if (query.status !== undefined) params.set('status', query.status);

  const serialized = params.toString();
  return serialized ? `?${serialized}` : '';
}

/**
 * Learning & Development › Training Recommendations — read only, on
 * `training-recommendations.read`. One recommendation, its employees and their tracks are read
 * through `surveyTrainingRecommendationsApi`, which answers this module's key too; writing,
 * submitting and sending one are Survey's own calls, on Survey's keys.
 */
export const trainingRecommendationsApi = {
  /** The register's rows — every plan's training recommendations, across every survey. */
  list: (query: TrainingRecommendationListQuery, signal?: AbortSignal) =>
    api<PagedResult<SurveyTrainingRecommendation>>(`/api/training-recommendations${toQueryString(query)}`, { signal }),
};
